<template>
  <!-- 个人信息 -->
  <div class="drawer-info home-info">

    <el-drawer title="我是标题" :visible.sync="drawer" :with-header="false" :wrapperClosable="false">
      <div class="drawer-wrap">
        <div class="drawer-boxs">
          <div class="headers-page ">

            <div class="hearders-title hairline-bottom">
              <div class="hearders-padding pages-box">
                <div class="left">
                  <img src="./../../../../assets/homes/appicon.png" class="left-logo" alt="">
                  <div class="left-title">
                    常用应用
                  </div>
                </div>
              </div>
            </div>

            <div class="datas-padding">
              <!-- <div class="data-content">

                <div class="data-box box2" v-for="(item, index) in selectList" :key="index">
                  <div class="data-box-padding data-flex">
                    <img class="data-icon" :src="item.serviceIcon" alt="">
                    <div class="data-title">
                      {{ item.serviceName }}
                    </div>
                  </div>
                  <div class="del-icon" @click="delItemBtn(item, index, -1)">
                    <img src="./../../../../assets/homes/jian.png" class="del-logo" alt="">
                  </div>
                </div>

              </div> -->

              <div class="data-content-box">

                <div class="data-box-ul" v-for="(item, index) in selectList" :key="index">

                  <div class="data-icon-list" style="position: relative;">
                    <img :src="item.serviceIcon" alt="">
                    <div class="del-icon" @click="delItemBtn(item, index, -1)">
                      <img src="./../../../../assets/homes/del-icos.png" class="del-logo" alt="">
                    </div>
                  </div>

                  <div class="data-title-list">
                    {{ item.serviceName }}
                  </div>
                </div>
              </div>

            </div>

          </div>

          <div class="headers-page " v-for="(item,index) in allList" :key="index">
            <div class="hearders-title hairline-bottom">
              <div class="hearders-padding pages-box">
                <div class="left">
                  <img :src="item.groupIcon" class="left-logo" alt="">
                  <div class="left-title">
                    {{item.groupName}}
                  </div>
                </div>
              </div>

            </div>
            <div class="datas-padding">
              <div class="data-content-box">
                <div class="data-box-ul" v-for="(it, ind) in item.serviceVOList" :key="ind">

                  <div class="data-icon-list" style="position: relative;">
                    <img class="data-icon" :src="it.serviceIcon" alt="">

                    <div class=" add-icon" v-if="it.isDeal == false" @click="addBtn(it, index, ind)">
                      <img src="./../../../../assets/homes/add-icons.png" class="add-logo" alt="">
                    </div>
                    <div class="del-icon" v-if="it.isDeal == true" @click="delBtn(it, index, ind)">
                      <img src="./../../../../assets/homes/del-icos.png" class="del-logo" alt="">
                    </div>
                  </div>

                  <div class="data-title-list">
                    {{ it.serviceName }}
                  </div>

                </div>

              </div>

            </div>
          </div>

          <div style="height: 60px"></div>
        </div>
        <div class="sub-boxs">
          <div class="sub">
            <div class="sub-btn submit" @click="okBtn">确定</div>
            <div class="sub-btn skip" @click="cancelBtn">取消</div>
          </div>
        </div>

      </div>

    </el-drawer>
  </div>
</template>
<script>
import { saveBatchMyService } from '../../../../api/api.p'


import axios from 'axios';

export default {
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    list: {//全部
      type: Array,
      default: () => [] // 提供一个默认空数组，如果没有传递数组
    },
    arr: {//选中
      type: Array,
      default: () => [] // 提供一个默认空数组，如果没有传递数组
    },
  },
  data () {
    return {

      //抽屉数据
      selectList: [],
      allList: [],

    }
  },
  filters: {},
  components: {

  },
  created () {
  },
  mounted () {
    this.init()

  },
  methods: {
    goData (item) {
      window.open(item.homeUrl)
      // window.location.href = item.homeUrl
    },
    okBtn () {

      // console.log(this.selectList)
      if (this.selectList.length > 12) {
        this.$toast({
          duration: 5000, // 持续展示 toast
          message: '您添加的常用应用不能超过12个',
        })
      } else if (this.selectList.length <= 0) {
        this.$toast('请先选择要添加的应用')
      } else {
        this.saveBatchMyService()
      }
    },
    cancelBtn () {
      this.$emit('cancel-parent-method');
    },
    async saveBatchMyService (item) {
      let data = JSON.parse(JSON.stringify(this.selectList));
      // 使用 map 方法获取 serviceId
      let serviceIds = data.map(item => item.serviceId);

      let param = {
        "orgId": "",
        "serviceIds": serviceIds
      }
      const res = await saveBatchMyService(param);
      if (res) {

        if (res.meta.code == 0) {
          if (res.data == true) {
            this.$emit('call-parent-method');
          } else {
            this.$toast('应用保存失败');
          }


        } else {
          this.$toast(res.meta.message);
        }

      } else {

        this.$toast('操作失败');
      }

    },
    init () {
      this.selectList = JSON.parse(JSON.stringify(this.arr));
      this.allList = JSON.parse(JSON.stringify(this.list));
      this.updateIsDeal()
    },
    delItemBtn (selectedItem, selectIndex, allListIndex) {
      // 从 selectList 中移除当前对象
      this.selectList.splice(selectIndex, 1);

      // 遍历 allList 并更新 isDeal
      this.allList.forEach(group => {
        group.serviceVOList.forEach(service => {
          if (service.serviceId === selectedItem.serviceId) {
            service.isDeal = false;
          }
        });
      });
    },
    delBtn (selectedItem, allListIndex, serviceVOListIndex) {
      let indexs = 0
      let list = JSON.parse(JSON.stringify(this.selectList));

      for (let i = 0; i < list.length; i++) {
        if (list[i].serviceId == selectedItem.serviceId) {
          indexs = -1
          this.selectList.splice(i, 1);
        }
      }
      if (indexs == -1) {
        // 创建选中项的副本，并设置 isDeal 为 true
        const newItem = { ...selectedItem, isDeal: false };
        this.allList.forEach(group => {
          group.serviceVOList.forEach(service => {
            if (service.serviceId === selectedItem.serviceId) {
              service.isDeal = false;
            }
          });
        });
      }


    },
    addBtn (selectedItem, allListIndex, serviceVOListIndex) {
      let indexInSelectList = 0
      let list = JSON.parse(JSON.stringify(this.selectList));
      for (let i = 0; i < list.length; i++) {
        if (list[i].serviceId == selectedItem.serviceId) {
          indexInSelectList = -1
        }
      }
      if (indexInSelectList !== -1) {
        // 创建选中项的副本，并设置 isDeal 为 true
        const newItem = { ...selectedItem, isDeal: true };
        this.selectList.push(newItem);
        this.allList.forEach(group => {
          group.serviceVOList.forEach(service => {
            if (service.serviceId === selectedItem.serviceId) {
              service.isDeal = true;
            }
          });
        });
      }

    },
    updateIsDeal () {
      let selectList = this.selectList;
      let allList = this.allList;
      // 遍历 allList
      allList.forEach(group => {
        // 为每个 serviceVOList 项初始化 isDeal 为 false
        group.serviceVOList = group.serviceVOList.map(service => {
          return {
            ...service,
            isDeal: false // 初始化 isDeal 为 false
          };
        });

        // 再次遍历，检查是否有匹配 selectList 中的 serviceId
        selectList.forEach(selected => {
          group.serviceVOList.forEach(service => {
            if (service.serviceId === selected.serviceId) {
              service.isDeal = true; // 如果匹配，设置 isDeal 为 true
            }
          });
        });
      });

      console.log(allList)
    },
    /*获取列表*/
    async fetchTodoListFun () {

      let param = this.params;
      param.authType = this.authType;
      param.pageNumber = this.pageNum;
      param.numPerPage = this.pageSize

      let res = await fetchTodoList(param);
      let data = res.records

      if (data.length > 0) {

        data.forEach(ele => {
          let testArr = []
          for (let key in ele.keyList) {
            testArr.push({
              'name': ele.keyList[key],
              'value': ele.valueList[key]
            })
          }
          ele.testArr = testArr
        })

      }

      this.dataList = data;

    },

  },
}
</script>

<style lang="less" scoped>
@import './../../../../common/homeInfo';
/*
todo  按钮样式
*/
.search-display {
  display: inline-block;
}
.dialog-search-btn-box {
  width: 100%;
  text-align: right;
}

.del-icon {
  position: absolute;
  right: -10px;
  top: -10px;
  width: 16px;
  height: 16px;

  .del-logo {
    width: 100%;
    height: 100%;
  }
}
.add-icon {
  position: absolute;
  right: -10px;
  top: -10px;
  width: 16px;
  height: 16px;

  .add-logo {
    width: 100%;
    height: 100%;
  }
}

.search-btn-box,
.sub,
.dialog-footer {
  text-align: right;
  margin-top: 10px;

  .sub-btn {
    display: inline-block;
    border-radius: 4px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    padding: 0 12px;
  }

  //todo 添加 搜索 提交
  .submit {
    background: #4476f7;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
    margin-right: 10px;
    border: 1px solid #4476f7;
  }

  //todo  取消
  .skip {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #202020;
    background: #f8f8fa;
    border: 1px solid #eaeaea;
    cursor: pointer;
    margin-right: 10px;
  }

  //todo  删除
  .dels {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    background: #f56c6c;
    border: 1px solid #f56c6c;
    cursor: pointer;
  }
}

::v-deep.drawer-info {
  .drawer-wrap {
    z-index: 9999;
    display: flex; /* 启用flex布局 */
    flex-direction: column; /* 设置子元素垂直排列 */
    /* 其他样式 */
    min-height: 100vh;
  }
  .drawer-boxs {
    flex: 1;
  }
  .sub-boxs {
    width: 750px;
    height: 55px;
    background: #fff;
    position: fixed;
    bottom: 0;
  }
  .headerx-div {
    border-radius: 8px;
    margin-top: 24px;
  }
  .headers-page {
    width: 100%;
    background: #ffffff;

    .hearders-padding {
      padding: 0 24px;
    }

    .hearders-title {
      width: 100%;
      height: 54px;
      .pages-box {
        display: flex;
        align-items: center;
        height: 100%;
        .left {
          flex: 1;
          display: flex;
          align-items: center;
          .left-logo {
            width: 24px;
            height: 24px;
            margin-right: 8px;
          }
          .left-title {
            font-size: 16px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #202020;
          }
        }
        .right {
          flex: 1;
          text-align: right;
          span {
            font-family: SourceHanSansCN, SourceHanSansCN;
            font-weight: 500;
            font-size: 14px;
            color: #4476f7;
            line-height: 21px;
            font-style: normal;
            cursor: pointer;
          }
        }
      }
    }
    .datas-padding {
      padding: 24px;
    }
    .data-content {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .data-box {
        // flex: 0 0 23%; /* 每个元素占据父容器的20%宽度减去20px的左边距 calc(20% - 20px)*/
        // min-width: 23%;
        // margin-right: calc(9.99% / 4);
        width: 273px;
        height: 112px;
        margin-right: 20px;
        background: #f4f7fd;
        border-radius: 10px;
        margin-top: 20px;
        cursor: pointer;
        position: relative;
      } /* 选择类名为 'special-div' 的前四个 div */

      .box1,
      .box2:nth-of-type(1),
      .box1,
      .box2:nth-of-type(2),
      .box1,
      .box2:nth-of-type(3),
      .box1:nth-of-type(4) {
        margin-top: 0;
      }
      .box1:nth-child(4n) {
        margin-right: 0px;
      }
      .box2:nth-child(3n) {
        margin-right: 0px;
      }

      .data-box-padding {
        padding: 20px;
      }

      .data-flex {
        // min-width: 273px;
        display: flex;
        align-items: center; /* 垂直居中展示 */
        .data-icon {
          margin-right: 20px;
          width: 72px;
          height: 72px;
        }
        .data-title {
          flex: 1;
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #202020;

          display: -webkit-box;
          -webkit-line-clamp: 3; /* 最多显示三行 */
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .el-drawer {
    width: 770px !important;
  }
}
</style>


